import { ComplexBase } from '@syncfusion/ej2-react-base';
export class ImageDirective extends ComplexBase {
}
ImageDirective.moduleName = 'image';
export class ImagesDirective extends ComplexBase {
}
ImagesDirective.propertyName = 'image';
ImagesDirective.moduleName = 'images';
